module.exports = "<p>\n  exams-course-section-edit works!\n</p>\n"